if (!customElements.get('option-info')) {
  class OptionInfo extends HTMLElement {
    constructor () {
      super();
      this.controler = this.querySelector('.option-info');
      this.descrpition = this.querySelector('.option-description');
    }

    clickHandler () {
      this.descrpition.classList.toggle('active');
      const scrollContainer = this.closest('.variant-picker__option-values');
      document.querySelectorAll('.thumbnail-swatch + .option-description.active').forEach((item) => {
        if (item !== this.descrpition) {
          item.classList.remove('active');
        } else {
          if (item.classList.contains('active')) {
            if (scrollContainer) {
              setTimeout(() => {
                item.scrollIntoView({
                  behavior: 'smooth',
                  block: 'nearest',
                });
              }, 50);
            }
          }
        }
      });
    }

    connectedCallback () {
      if (this.controler && this.descrpition) {
        this.controler.addEventListener('click', this.clickHandler.bind(this));
      }
    }

    disconnectedCallback () {

    }
  }

  customElements.define('option-info', OptionInfo);
}

